import { UserService } from './../../core/services/user.service';
import { AlertService } from './../../core/services/alert.service';
import { ApiObjectData } from './../../core/models/api-object-data';
import { UserLogin } from './../../core/models/userLogin';
import { Component, ElementRef, OnInit, Pipe, ViewChild } from '@angular/core';
import { BaseComponent } from './../../components/base/base.component';
import { BaseService } from './../../core/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TokenAuthService } from '../../core/services/token-auth.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TeacherService } from '../../core/services/teacher.service';
import { Teacher } from '../../core/models/teacher';
import { User } from '../../core/models/user';
import { ContactService } from 'src/app/core/services/contact.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {
  @ViewChild('teacherForm', { static: false }) teacherForm: NgForm;
  @ViewChild('closeModal') closeModal: ElementRef
  userLogin = {} as UserLogin;
  tokenValid = false;
  token: string;
  academyToken:string;
  userId: any;
  teacher = {} as Teacher;
  user = {} as User;

  userFullName: string;
  profilePic
  teacherId: any;
  isTeacher: any;

  userName: string;

  resetPasswordPopup: boolean =false;

  resetEmailValue: string;

  loading = false;

  constructor(
    public baseService:BaseService,
    private tokenAuthService: TokenAuthService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private teacherService: TeacherService,
    private userService: UserService,
    private contactService: ContactService
  ) { super() }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }
  }

  login() {
    debugger
    this.loading = true;
    this.baseService.blockStart();
    this.tokenAuthService.login(this.userLogin).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        if (data.success === true) {
          if(data.result.message === 'Error in Singing Lms') {
            this.alertService.error(this.translate.instant('ErrorLMS'));
            this.loading = false;
          }
          else {
          // console.log(data.result);
          this.token = data.result.accessToken;
          this.academyToken = data.result.academyToken;
          this.userId = data.result.userId;
          localStorage.setItem('token', this.token);
          localStorage.setItem('academyToken', this.academyToken);
          localStorage.setItem('userId', this.userId);
          
          this.teacherService.getByUserId(this.userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (logedData: any) => {
              this.loading = false;
              this.baseService.blockStop();
              if (logedData.success === true) {
                this.alertService.success(this.translate.instant('loginSuccessfully'));
                this.userFullName = logedData.result.returnData.user.fullName;
                localStorage.setItem('userFullName', this.userFullName);

                this.userName = logedData.result.returnData.user.userName;
                localStorage.setItem('userName', this.userName);

                

                if (logedData.result.returnData.isTeacher === true) {
                  this.profilePic = logedData.result.returnData.profileImg;
                  localStorage.setItem('profileImg', this.profilePic);
                }

                else if (logedData.result.returnData.isTeacher === false) {
                  this.profilePic = logedData.result.returnData.img;
                  localStorage.setItem('profileImg', this.profilePic);
                }


                

                this.isTeacher = logedData.result.returnData.isTeacher;
                localStorage.setItem('isTeacher', this.isTeacher);
                if(this.isTeacher === true) {
                  this.teacherId = logedData.result.returnData.id;
                  localStorage.setItem('teacherId', this.teacherId);
                  localStorage.setItem('studentId', null)
                }
                else if(this.isTeacher === false) {
                  localStorage.setItem('studentId', logedData.result.returnData.id);
                  localStorage.setItem('teacherId', null)
                }
                this.router.navigate(['/home']);
              }
            }
          )
          }

        }
        // else if (data.success === false) {
        //   this.baseService.blockStop();
        //   this.alertService.error(data.error.details);
        // }
        else {
          this.loading = false;
          this.baseService.blockStop();
          this.alertService.error(this.translate.instant('loginerror'));
        }
      },
      error => {
        this.loading = false;
        this.baseService.blockStop();
        if (error.error.error.details === 'InvalidPassword') {
          this.alertService.error(this.translate.instant('passIsWrong'));
        }
        else if (error.error.error.details === 'InvalidUserNameOrEmailAddress') {
          this.alertService.error(this.translate.instant('nameOrEmailIsWrong'));
        }
        else {
          this.alertService.error(this.translate.instant('smthWentWrong'));
          // this.alertService.error(error.error.error.details);
        }
      }
    )
  }

  changeInput(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  ForgetPassPop() {
    this.resetPasswordPopup = true;
  }

  sendResetPass() {
    debugger
    this.loading = true;
    var lang = localStorage.getItem('lang');
    this.userService.getUserByUserNameOrEmail(this.resetEmailValue).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.user = data.result.returnData;
        this.user.lang = lang
        this.contactService.forgetPassword(this.user).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (data: any) => {
            // console.log(data)
            this.loading = false;
            if (data.success === true) {
              this.closeModal.nativeElement.click()
              this.alertService.success(this.translate.instant('emailSent'));
              // document.getElementById("closeModalButton").click();
            }
            else {
              this.alertService.error(this.translate.instant('smthWentWrong'));
            }
          }
        )

      }
    )
  }

}
